package org.gstechnovos.jexonplastech.sections.products.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth

@Composable
fun ProductsCatalogSection() {
    var currentCategory by remember { mutableStateOf("All") }
    var searchQuery by remember { mutableStateOf("") }

    Column(modifier = Modifier.fillMaxWidth()) {
        ProductsFilterSection(
            selectedCategory = currentCategory,
            onCategorySelect = { newCategory -> currentCategory = newCategory },
            searchQuery = searchQuery,
            onSearchChange = { newQuery -> searchQuery = newQuery }
        )

        ProductsGridSection(
            selectedCategory = currentCategory,
            searchQuery = searchQuery,
            // NEW: Pass a callback to reset all filters from the empty state
            onClearFilters = {
                currentCategory = "All"
                searchQuery = ""
            }
        )
    }
}